/**
 * KAN-956: строка раздела "Встречи и перезвоны": клиент, вид шага, заметка,
 * менеджер, время (у просроченных дата и красная пометка), кнопка "Позвонить".
 */
import { ClientAvatar } from '@/components/clients/ClientAvatar'
import { ManagerCallButton } from '@/components/clients/ManagerCallButton'
import type { CallButtonSize } from '@/components/clients/ManagerCallParts'
import { formatStepTime } from '@/lib/todaySteps'
import type { TodayStepItem } from '@/services/api/todaySteps'

interface TodayStepRowProps {
  item: TodayStepItem
  timeZone: string
  onOpen: (item: TodayStepItem) => void
  callSize: CallButtonSize
}

export function TodayStepRow({ item, timeZone, onOpen, callSize }: TodayStepRowProps) {
  const title = item.name || item.phone || 'Клиент'
  return (
    <li data-testid={`today-step-${item.client_id}`} className="flex flex-wrap items-center gap-3 px-4 py-3">
      <button
        type="button"
        onClick={() => onOpen(item)}
        className="flex min-w-0 flex-1 items-start gap-3 rounded-lg text-left hover:bg-gray-50"
      >
        <ClientAvatar avatarUrl={item.avatar_url} name={title} size={40} />
        <span className="min-w-0 flex-1">
          <span className="flex flex-wrap items-baseline gap-x-2">
            <span className="truncate font-medium text-gray-900">{title}</span>
            <span className="text-sm text-gray-600">{item.step_label}</span>
          </span>
          {item.note && <span className="block truncate text-sm text-gray-800">{item.note}</span>}
          {item.manager && <span className="block text-xs text-gray-500">Менеджер: {item.manager.full_name}</span>}
        </span>
        <span className="shrink-0 text-right">
          <span className={`block text-sm font-semibold ${item.overdue ? 'text-red-600' : 'text-gray-900'}`}>
            {formatStepTime(item.followup_at, timeZone, item.overdue)}
          </span>
          {item.overdue && <span className="block text-xs font-medium text-red-600">просрочено</span>}
        </span>
      </button>
      {item.phone && (
        <ManagerCallButton
          clientId={item.client_id}
          phone={item.phone}
          size={callSize}
          targetMode="onClick"
          testId={`today-step-call-${item.client_id}`}
        />
      )}
    </li>
  )
}
